export default __webpack_public_path__ + "static/media/FotosVideos-orange.b193e964.svg";